var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMindMapIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a44fb94c68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 249.597656 253.667969 L 482.691406 253.667969 L 482.691406 486.761719 L 249.597656 486.761719 Z M 249.597656 253.667969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d1b286b46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 366.144531 253.667969 C 301.777344 253.667969 249.597656 305.847656 249.597656 370.214844 C 249.597656 434.582031 301.777344 486.761719 366.144531 486.761719 C 430.511719 486.761719 482.691406 434.582031 482.691406 370.214844 C 482.691406 305.847656 430.511719 253.667969 366.144531 253.667969 Z M 366.144531 253.667969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cca0f03220"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 249.597656 253.667969 L 482.683594 253.667969 L 482.683594 486.753906 L 249.597656 486.753906 Z M 249.597656 253.667969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4089ff1e2a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 366.140625 253.667969 C 301.777344 253.667969 249.597656 305.847656 249.597656 370.210938 C 249.597656 434.578125 301.777344 486.753906 366.140625 486.753906 C 430.507812 486.753906 482.683594 434.578125 482.683594 370.210938 C 482.683594 305.847656 430.507812 253.667969 366.140625 253.667969 Z M 366.140625 253.667969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e24f93be55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 430.167969 61.597656 L 559.792969 61.597656 L 559.792969 191.222656 L 430.167969 191.222656 Z M 430.167969 61.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce85e9a3ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 494.980469 61.597656 C 459.1875 61.597656 430.167969 90.613281 430.167969 126.410156 C 430.167969 162.203125 459.1875 191.222656 494.980469 191.222656 C 530.777344 191.222656 559.792969 162.203125 559.792969 126.410156 C 559.792969 90.613281 530.777344 61.597656 494.980469 61.597656 Z M 494.980469 61.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1cc958878b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 430.167969 61.597656 L 559.789062 61.597656 L 559.789062 191.21875 L 430.167969 191.21875 Z M 430.167969 61.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d1869facf6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 494.980469 61.597656 C 459.1875 61.597656 430.167969 90.613281 430.167969 126.40625 C 430.167969 162.199219 459.1875 191.21875 494.980469 191.21875 C 530.773438 191.21875 559.789062 162.199219 559.789062 126.40625 C 559.789062 90.613281 530.773438 61.597656 494.980469 61.597656 Z M 494.980469 61.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b7ef3d3d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 581.492188 228.203125 L 760.476562 228.203125 L 760.476562 407.1875 L 581.492188 407.1875 Z M 581.492188 228.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f0910b88b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 670.984375 228.203125 C 621.558594 228.203125 581.492188 268.273438 581.492188 317.695312 C 581.492188 367.121094 621.558594 407.1875 670.984375 407.1875 C 720.40625 407.1875 760.476562 367.121094 760.476562 317.695312 C 760.476562 268.273438 720.40625 228.203125 670.984375 228.203125 Z M 670.984375 228.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3976034a80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 581.492188 228.203125 L 760.472656 228.203125 L 760.472656 407.183594 L 581.492188 407.183594 Z M 581.492188 228.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "308d59ed4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 670.980469 228.203125 C 621.554688 228.203125 581.492188 268.269531 581.492188 317.695312 C 581.492188 367.117188 621.554688 407.183594 670.980469 407.183594 C 720.40625 407.183594 760.472656 367.117188 760.472656 317.695312 C 760.472656 268.269531 720.40625 228.203125 670.980469 228.203125 Z M 670.980469 228.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa3e6af2af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 516.140625 565.78125 L 698.765625 565.78125 L 698.765625 748.402344 L 516.140625 748.402344 Z M 516.140625 565.78125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "45f066fad2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 607.453125 565.78125 C 557.023438 565.78125 516.140625 606.664062 516.140625 657.09375 C 516.140625 707.523438 557.023438 748.402344 607.453125 748.402344 C 657.882812 748.402344 698.765625 707.523438 698.765625 657.09375 C 698.765625 606.664062 657.882812 565.78125 607.453125 565.78125 Z M 607.453125 565.78125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4336cacb48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 516.140625 565.78125 L 698.390625 565.78125 L 698.390625 748.03125 L 516.140625 748.03125 Z M 516.140625 565.78125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "872faea6a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 607.449219 565.78125 C 557.019531 565.78125 516.140625 606.660156 516.140625 657.085938 C 516.140625 707.515625 557.019531 748.394531 607.449219 748.394531 C 657.875 748.394531 698.753906 707.515625 698.753906 657.085938 C 698.753906 606.660156 657.875 565.78125 607.449219 565.78125 Z M 607.449219 565.78125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8a3276d39f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.082031 472.894531 L 255.792969 472.894531 L 255.792969 644.601562 L 84.082031 644.601562 Z M 84.082031 472.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6e0ad2b9c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.9375 472.894531 C 122.523438 472.894531 84.082031 511.332031 84.082031 558.746094 C 84.082031 606.164062 122.523438 644.601562 169.9375 644.601562 C 217.355469 644.601562 255.792969 606.164062 255.792969 558.746094 C 255.792969 511.332031 217.355469 472.894531 169.9375 472.894531 Z M 169.9375 472.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "597b0215bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.082031 472.894531 L 255.785156 472.894531 L 255.785156 644.597656 L 84.082031 644.597656 Z M 84.082031 472.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2fd8971aab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.933594 472.894531 C 122.519531 472.894531 84.082031 511.328125 84.082031 558.746094 C 84.082031 606.160156 122.519531 644.597656 169.933594 644.597656 C 217.347656 644.597656 255.785156 606.160156 255.785156 558.746094 C 255.785156 511.328125 217.347656 472.894531 169.933594 472.894531 Z M 169.933594 472.894531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2dea2cdf36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.523438 110.453125 L 185.09375 110.453125 L 185.09375 246.023438 L 49.523438 246.023438 Z M 49.523438 110.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "170b59f20d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117.308594 110.453125 C 79.875 110.453125 49.523438 140.804688 49.523438 178.238281 C 49.523438 215.675781 79.875 246.023438 117.308594 246.023438 C 154.746094 246.023438 185.09375 215.675781 185.09375 178.238281 C 185.09375 140.804688 154.746094 110.453125 117.308594 110.453125 Z M 117.308594 110.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c99861ca48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.523438 110.453125 L 185.085938 110.453125 L 185.085938 246.015625 L 49.523438 246.015625 Z M 49.523438 110.453125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9469df8d81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117.304688 110.453125 C 79.871094 110.453125 49.523438 140.800781 49.523438 178.234375 C 49.523438 215.671875 79.871094 246.015625 117.304688 246.015625 C 154.742188 246.015625 185.085938 215.671875 185.085938 178.234375 C 185.085938 140.800781 154.742188 110.453125 117.304688 110.453125 Z M 117.304688 110.453125 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a44fb94c68)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d1b286b46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cccccc",
    d: "M 249.597656 253.667969 L 482.691406 253.667969 L 482.691406 486.761719 L 249.597656 486.761719 Z M 249.597656 253.667969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cca0f03220)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4089ff1e2a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 249.599552, 253.668406)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 155.388105 -0.000582518 C 69.570393 -0.000582518 -0.00252732 69.572338 -0.00252732 155.39005 C -0.00252732 241.212971 69.570393 310.780683 155.388105 310.780683 C 241.211026 310.780683 310.778738 241.212971 310.778738 155.39005 C 310.778738 69.572338 241.211026 -0.000582518 155.388105 -0.000582518 Z M 155.388105 -0.000582518 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e24f93be55)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce85e9a3ff)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fb8b24",
    d: "M 430.167969 61.597656 L 559.792969 61.597656 L 559.792969 191.222656 L 430.167969 191.222656 Z M 430.167969 61.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1cc958878b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d1869facf6)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 430.169886, 61.596579)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 86.414115 0.001437 C 38.690154 0.001437 -0.00255615 38.688939 -0.00255615 86.4129 C -0.00255615 134.13686 38.690154 172.829571 86.414115 172.829571 C 134.138076 172.829571 172.825578 134.13686 172.825578 86.4129 C 172.825578 38.688939 134.138076 0.001437 86.414115 0.001437 Z M 86.414115 0.001437 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b7ef3d3d1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f0910b88b3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54ff71",
    d: "M 581.492188 228.203125 L 760.476562 228.203125 L 760.476562 407.1875 L 581.492188 407.1875 Z M 581.492188 228.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3976034a80)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#308d59ed4a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 581.490262, 228.204354)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 119.320289 -0.00163883 C 53.41924 -0.00163883 0.00256701 53.420242 0.00256701 119.321291 C 0.00256701 185.217132 53.41924 238.639013 119.320289 238.639013 C 185.221338 238.639013 238.643219 185.217132 238.643219 119.321291 C 238.643219 53.420242 185.221338 -0.00163883 119.320289 -0.00163883 Z M 119.320289 -0.00163883 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa3e6af2af)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#45f066fad2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4a4a",
    d: "M 516.140625 565.78125 L 698.765625 565.78125 L 698.765625 748.402344 L 516.140625 748.402344 Z M 516.140625 565.78125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4336cacb48)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#872faea6a0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 516.141434, 565.78072)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 121.743712 0.000707285 C 54.50413 0.000707285 -0.00107804 54.505915 -0.00107804 121.740289 C -0.00107804 188.979871 54.50413 243.485079 121.743712 243.485079 C 188.978086 243.485079 243.483294 188.979871 243.483294 121.740289 C 243.483294 54.505915 188.978086 0.000707285 121.743712 0.000707285 Z M 121.743712 0.000707285 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8a3276d39f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6e0ad2b9c6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff78e6",
    d: "M 84.082031 472.894531 L 255.792969 472.894531 L 255.792969 644.601562 L 84.082031 644.601562 Z M 84.082031 472.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#597b0215bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2fd8971aab)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 84.083085, 472.892924)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 114.467351 0.00214272 C 51.248598 0.00214272 -0.00140483 51.246937 -0.00140483 114.470898 C -0.00140483 177.689652 51.248598 228.939654 114.467351 228.939654 C 177.686104 228.939654 228.936107 177.689652 228.936107 114.470898 C 228.936107 51.246937 177.686104 0.00214272 114.467351 0.00214272 Z M 114.467351 0.00214272 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2dea2cdf36)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#170b59f20d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33adff",
    d: "M 49.523438 110.453125 L 185.09375 110.453125 L 185.09375 246.023438 L 49.523438 246.023438 Z M 49.523438 110.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c99861ca48)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9469df8d81)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 49.524702, 110.45436)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 90.373319 -0.00164672 C 40.461858 -0.00164672 -0.00168574 40.461897 -0.00168574 90.373358 C -0.00168574 140.290027 40.461858 180.748362 90.373319 180.748362 C 140.289988 180.748362 180.748323 140.290027 180.748323 90.373358 C 180.748323 40.461897 140.289988 -0.00164672 90.373319 -0.00164672 Z M 90.373319 -0.00164672 ",
    stroke: "var(--txt-color)",
    strokeWidth: 14,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.386876, -0.642516, 0.642516, 0.386876, 411.096079, 265.210759)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.0022191 6.001701 L 135.784615 6.002065 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.734106, -0.153586, 0.153586, 0.734106, 478.411683, 354.020803)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00161614 6.000129 L 146.360901 5.998392 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.522393, -0.53815, 0.53815, 0.522393, 228.894191, 497.592235)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00179721 6.001798 L 97.015019 6.003093 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.444609, -0.604006, 0.604006, -0.444609, 546.119856, 593.674022)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.000205711 5.997031 L 232.65083 5.999092 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(-0.579688, -0.47588, 0.47588, -0.579688, 274.064198, 302.733139)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00248786 5.999862 L 180.292651 6.000601 ",
    stroke: "var(--txt-color)",
    strokeWidth: 12,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindMapIconLight);
export default __webpack_public_path__ + "static/media/mind_map_icon_light.0f19a0dc628a4a7c056a20467a54f1ab.svg";
export { ForwardRef as ReactComponent };